// src/contexts/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../config/firebaseConfig';

const AuthContext = createContext();

// Hook personnalisé pour utiliser le contexte facilement
export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Écouteur natif Firebase v8
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentUser(user);
      setLoading(false); // Firebase a fini de vérifier la session
    });

    return unsubscribe; // Nettoyage de l'écouteur
  }, []);

  const value = {
    currentUser
  };

  return (
    <AuthContext.Provider value={value}>
      {/* On n'affiche l'application que lorsque Firebase a fini sa vérification */}
      {!loading && children}
    </AuthContext.Provider>
  );
}
